import { render } from "./OffCanvas.vue?vue&type=template&id=2c6c8550&scoped=true"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=2c6c8550&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6c8550"]])

export default __exports__